import React from "react";
import PageHeader from "../../components/common/PageHeader";
import ApplyForFranchise from "../../components/Franchise User Side/ApplyForFranchise";

const FranchiseUser = () => {
  return (
    <div>
      <PageHeader pageName={"Apply for Franchise"} />
      <ApplyForFranchise />
    </div>
  );
};

export default FranchiseUser;
